import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Form, Input, Select, Flex, DatePicker } from "antd";
import ModalComponent from "@/components/modal";
import "@/styles/pages/guide/guide-platform.scss";
import ButtonComponent from "@/components/button/Button";
import { useDispatch, useSelector } from "react-redux";
import BackWithLabel from "@/components/common/BackWithLabel";
import Dragger from "antd/es/upload/Dragger";
import IconUploadDocs from "@/components/icons/IconUploadDocs";
import { getLevels } from "@/services/common/getLevels";
import { getDisciplines } from "@/services/common/getDisciplines";
import IconCross from "@/components/icons/IconCross";
import { getUniversityByCountryAndRegion } from "@/services/common/getUniversityByCountryAndRegion";
import { getRegionByCountry } from "@/services/common/getRegionByCountry";
import { createGuideProfile } from "@/services/guides/createGuideProfile";
import { uploadFile } from "@/services/users/uploadFile";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@/components/toaster/Toaster";
import { getUserFileByCategory } from "@/services/users/getUserFileByCategory";
import {
  getUserInfo,
  setCurrentForm,
  setGuidePlatformCloseManually,
  setModalOpen,
} from "@/reducers/commonSlice";
import dayjs from "dayjs";
import { countryList } from "@/helpers/countryList";
import { updateStage } from "@/services/users/updateStage";
import { updateUserRole } from "@/services/users/updateUserRole";
import IconAttachment from "@/components/icons/IconAttachment";
import { updateFile } from "@/services/users/updateFile";

const tagRender = (props) => {
  const { label, onClose } = props;

  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div className={"selected-chip"} onMouseDown={onPreventMouseDown}>
      <span>{label}</span>{" "}
      <IconCross style={{ cursor: "pointer" }} color={"#db5800"} onClick={onClose} />
    </div>
  );
};

const { Option } = Select;

const level = [
  {
    value: "UG",
    label: "UG",
  },
  {
    value: "PG",
    label: "PG",
  },
];

const GuidePlatform = ({ isOpen = false }) => {
  const navigate = useNavigate();
  const [regionOptions, setRegionOption] = useState([]);
  const [universityOptions, setUniverityOption] = useState([]);
  const [disciplineOption, setDisciplineOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [levelOptions, setLevelOptions] = useState([]);
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [isOtherDisciplineSelected, setIsOtherDisciplineSelected] = useState(false);
  const [studentIdFile, setStudentIdFile] = useState(null);
  const [resumeFile, setResumeFile] = useState(null);
  const userData = useSelector(getUserInfo);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      getUserFileByCategory([5, 2]).then((files) => {
        const studentId = files.find((file) => file.fileCategoryId === 5);
        const resume = files.find((file) => file.fileCategoryId === 2);
        if (studentId) {
          setStudentIdFile(studentId);
          form.setFieldsValue({
            studentId: [
              {
                uid: studentId.id,
                name: studentId.fileName,
                status: "done",
                url: studentId.signedUrl,
                thumbUrl: studentId.signedUrl,
              },
            ],
          });
        }
        if (resume) {
          setResumeFile(resume);
          form.setFieldsValue({
            resume: [
              {
                uid: resume.id,
                name: resume.fileName,
                status: "done",
                url: resume.signedUrl,
                thumbUrl: resume.signedUrl,
              },
            ],
          });
        }
      });
    }
  }, [isOpen]);

  const handleUniversityChange = (value) => {
    if (value === "other") {
      setIsOtherSelected(true);
    } else {
      setIsOtherSelected(false);
      form.setFieldsValue({ universityName: "" });
    }
  };

  const handleDisciplineChange = (value) => {
    if (value === 0) {
      setIsOtherDisciplineSelected(true);
    } else {
      setIsOtherDisciplineSelected(false);
      form.setFieldsValue({ courseName: "" });
    }
  };

  const disableCurrentAndFutureYears = (current) => {
    return current && current.year() > dayjs().year();
  };

  const getFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const handleFileChange = (fieldName, fileList) => {
    form.setFieldsValue({
      [fieldName]: fileList,
    });
  };

  const handleFinish = async (values) => {
    console.log(values, "values");
    try {
      await updateUserRole({ userRole: "Guide" });
    } catch (error) {
      console.error(error.response?.data?.msg ?? error?.msg);
    }

    const formData1 = new FormData();
    const formData2 = new FormData();
    let studentIdFileId = null;
    let resumeFileId = null;

    // Handle student ID file
    if (values.studentId?.[0]?.originFileObj) {
      if (studentIdFile) {
        // Update existing file
        studentIdFileId = studentIdFile.id;
        formData1.append("file", values.studentId[0].originFileObj);
      } else {
        // Upload new file
        formData1.append("file", values.studentId[0].originFileObj);
      }
    }

    // Handle resume file
    if (values.resume?.[0]?.originFileObj) {
      if (resumeFile) {
        // Update existing file
        resumeFileId = resumeFile.id;
        formData2.append("file", values.resume[0].originFileObj);
      } else {
        // Upload new file
        formData2.append("file", values.resume[0].originFileObj);
      }
    }

    const updatedData = {
      ...values,
      universityId: values.universityId === "other" ? 0 : values.universityId,
      yearOfCompletion: dayjs(values.yearOfCompletion).format("YYYY"),
      yearOfCommencement: dayjs(values.yearOfCommencement).format("YYYY"),
    };

    try {
      const uploadPromises = [];

      // Handle student ID file
      if (formData1.has("file")) {
        if (studentIdFileId) {
          uploadPromises.push(updateFile(studentIdFileId, formData1));
        } else {
          uploadPromises.push(uploadFile(5, formData1));
        }
      }

      // Handle resume file
      if (formData2.has("file")) {
        if (resumeFileId) {
          uploadPromises.push(updateFile(resumeFileId, formData2));
        } else {
          uploadPromises.push(uploadFile(2, formData2));
        }
      }

      if (uploadPromises.length > 0) {
        const results = await Promise.allSettled(uploadPromises);
        const allSuccessful = results.every((result) => result.status === "fulfilled");
        if (allSuccessful) {
          showNotification("success", "Files uploaded successfully");
        } else {
          showNotification("error", "Some files failed to upload");
        }
      }

      await createGuideProfile(updatedData);
      updateStage({
        stage: "AlreadyAtUniversity",
      });
      dispatch(setModalOpen(false));
      dispatch(setCurrentForm("guideSubmitted"));
      dispatch(setModalOpen(true));
    } catch (error) {
      console.error("Unexpected error:", error);
      showNotification("error", "An unexpected error occurred");
    }
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const fetchLevels = () => {
    getLevels().then((response) => {
      setLevelOptions(response?.map((x) => ({ label: x.name, value: x.id })));
    });
  };

  const fetchDiscipline = () => {
    getDisciplines().then((response) => {
      setDisciplineOptions(response?.map((x) => ({ label: x.name, value: x.id })));
    });
  };

  const fetchRegionData = () => {
    getRegionByCountry(selectedCountry)
      .then((response) => {
        setRegionOption([]);
        setRegionOption(response?.map((x) => ({ label: x.name, value: x.id })));
        form.resetFields(["regionIds"]);
        form.resetFields(["universityId"]);
        setSelectedRegion([]);
        setUniverityOption([]);
      })
      .catch((error) => console.log(error));
  };

  const fetchUniversity = () => {
    if (selectedCountry && selectedRegion) {
      getUniversityByCountryAndRegion(selectedCountry, selectedRegion)
        .then((response) => {
          setUniverityOption(response?.map((x) => ({ label: x.name, value: x.id })));
        })
        .catch((error) => console.log(error));
    }
  };

  useEffect(() => {
    if (selectedCountry?.length) {
      fetchRegionData();
    }
  }, [selectedCountry]);

  useEffect(() => {
    fetchUniversity();
  }, [selectedRegion]);

  useEffect(() => {
    fetchLevels();
    fetchDiscipline();
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <Fragment>
      <ModalComponent
        buttonLabel="Guide Platform"
        isOpen={isOpen}
        width={1257}
        maskClosable={false}
        closeIcon={true}
        className="guide-platform-modal"
        onCancelClick={() => {
          dispatch(setGuidePlatformCloseManually(true));
        }}
      >
        <div className="guide-platform-modal">
          <div className="card">
            <div className="heading">
              <BackWithLabel
                label={"Fill the form to become a mentor on our platform."}
                path="/dashboard"
              />
            </div>
            <p className="sub-heading">
              Please complete the form carefully; it will be reviewed by our backend team.
            </p>
            <Form
              name="guidePlatformForm"
              initialValues={{ remember: true }}
              layout="vertical"
              form={form}
              onFinish={handleFinish}
              onFinishFailed={(errorInfo) => {
                console.log(errorInfo, "errorInfo");
              }}
            >
              <Row gutter={[16, 4]} className="sideborder">
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Country"
                    name="countryCode"
                    rules={[
                      {
                        required: true,
                        message: "Please select Country",
                      },
                    ]}
                  >
                    <Select
                      virtual={false}
                      showSearch
                      placeholder="Select a Country"
                      className="w-100"
                      onChange={(value) => {
                        setSelectedCountry(value);
                        setSelectedRegion([]);
                      }}
                      filterOption={filterOption}
                    >
                      {countryList.map((country) => {
                        return (
                          <Option key={country.name} value={country.isoCode} label={country.name}>
                            <Flex justify="start" align="center" gap={"5px"}>
                              <img
                                src={country.flag}
                                height={30}
                                width={30}
                                className={"disabled-image"}
                              />
                              <span>{country.name}</span>
                            </Flex>
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="University"
                    name="universityId"
                    rules={[
                      {
                        required: true,
                        message: "Please select University",
                      },
                    ]}
                  >
                    <Select
                      virtual={false}
                      showSearch
                      placeholder="Select a university"
                      className="w-100 multiSelect"
                      defaultBg={"#fff5f0"}
                      defaultColor={"#DB5800"}
                      tagRender={tagRender}
                      options={[...universityOptions, { label: "Other", value: "other" }]}
                      filterOption={filterOption}
                      onChange={handleUniversityChange}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Other University"
                    name="universityName"
                    rules={[
                      {
                        required: isOtherSelected,
                        message: "Please enter the university name",
                      },
                    ]}
                  >
                    <Input placeholder="Enter university name" disabled={!isOtherSelected} />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Country of Origin"
                    name="countryOfOriginCode"
                    rules={[
                      {
                        required: true,
                        message: "Please select Country of Origin",
                      },
                    ]}
                  >
                    <Select
                      virtual={false}
                      showSearch
                      placeholder="Select a Country"
                      className="w-100"
                      filterOption={filterOption}
                    >
                      {countryList.map((country) => {
                        return (
                          <Option key={country.name} value={country.isoCode} label={country.name}>
                            <Flex justify="start" align="center" gap={"5px"}>
                              <img
                                src={country.flag}
                                height={30}
                                width={30}
                                className={"disabled-image"}
                              />
                              <span>{country.name}</span>
                            </Flex>
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="University Email"
                    name="universityEmail"
                    rules={[
                      {
                        type: "email",
                        required: true,
                        message: "Please enter a valid email address.",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your university Email" />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Level"
                    name="levelId"
                    rules={[
                      {
                        required: true,
                        message: "Please select Level",
                      },
                    ]}
                  >
                    <Select
                      virtual={false}
                      showSearch
                      placeholder="Select a Level"
                      className="w-100"
                      filterOption={filterOption}
                    >
                      {levelOptions?.map((country) => {
                        return (
                          <Option key={country.value} value={country.value} label={country.label}>
                            <div>{country.label}</div>
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Discipline"
                    name="disciplineId"
                    rules={[
                      {
                        required: true,
                        message: "Please select Discipline",
                      },
                    ]}
                  >
                    <Select
                      virtual={false}
                      showSearch
                      // maxTagCount={2}
                      // mode="multiple"
                      // maxCount={4}
                      placeholder="Select a Discipline"
                      className="w-100 multiSelect"
                      defaultBg={"#fff5f0"}
                      defaultColor={"#DB5800"}
                      tagRender={tagRender}
                      options={disciplineOption}
                      filterOption={filterOption}
                      onChange={handleDisciplineChange}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Other Course Name"
                    name="courseName"
                    rules={[
                      {
                        required: isOtherDisciplineSelected,
                        message: "Please enter the course name",
                      },
                    ]}
                  >
                    <Input placeholder="Enter course name" disabled={!isOtherDisciplineSelected} />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Year of commencement"
                    name="yearOfCommencement"
                    rules={[
                      {
                        required: true,
                        message: "Please enter year of commencement!",
                      },
                    ]}
                  >
                    <DatePicker
                      picker="year"
                      placeholder="Enter your year of commencement"
                      disabledDate={(current) => {
                        return current && current.year() > dayjs().year();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Year of completion"
                    name="yearOfCompletion"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the year of completion!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const startYear = getFieldValue("yearOfCommencement");
                          if (!value || !startYear || value.isAfter(startYear)) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Year of completion must be after the year of commencement!")
                          );
                        },
                      }),
                    ]}
                  >
                    <DatePicker picker="year" placeholder="Enter your year of completion" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 0]} justify="start" className={"sideborder"}>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="studentId"
                    label="Student ID Card/Student Visa"
                    className="upload-doc"
                    getValueFromEvent={getFile}
                    rules={[
                      {
                        required: !studentIdFile,
                        message: "Please select Student ID Card/Student Visa",
                      },
                    ]}
                  >
                    <div className="file-upload-container">
                      <Dragger
                        mode="multiple"
                        maxCount={1}
                        multiple={false}
                        beforeUpload={() => false}
                        defaultFileList={
                          studentIdFile
                            ? [
                                {
                                  uid: studentIdFile.id,
                                  name: studentIdFile.fileName,
                                  status: "done",
                                  url: studentIdFile.signedUrl,
                                  thumbUrl: studentIdFile.signedUrl,
                                },
                              ]
                            : []
                        }
                        onChange={(e) => handleFileChange("studentId", e.fileList)}
                      >
                        <p className="ant-upload-drag-icon">
                          <IconUploadDocs />
                        </p>
                        <p className="ant-upload-text">
                          {studentIdFile
                            ? "Click or drag file to update"
                            : "Tap here to upload the document."}
                        </p>
                      </Dragger>
                      {studentIdFile && (
                        <div className="file-info">
                          <Flex gap={"1rem"} align="center">
                            <IconAttachment />
                            <span>Current file: {studentIdFile.fileName}</span>
                          </Flex>
                        </div>
                      )}
                    </div>
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="resume"
                    label="CV/Resume"
                    className="upload-doc"
                    getValueFromEvent={getFile}
                    rules={[
                      {
                        required: !resumeFile,
                        message: "Please select CV/Resume",
                      },
                    ]}
                  >
                    <div className="file-upload-container">
                      <Dragger
                        mode="multiple"
                        maxCount={1}
                        multiple={false}
                        beforeUpload={() => false}
                        defaultFileList={
                          resumeFile
                            ? [
                                {
                                  uid: resumeFile.id,
                                  name: resumeFile.fileName,
                                  status: "done",
                                  url: resumeFile.signedUrl,
                                  thumbUrl: resumeFile.signedUrl,
                                },
                              ]
                            : []
                        }
                        onChange={(e) => handleFileChange("resume", e.fileList)}
                      >
                        <p className="ant-upload-drag-icon">
                          <IconUploadDocs />
                        </p>
                        <p className="ant-upload-text">
                          {resumeFile
                            ? "Click or drag file to update"
                            : "Tap here to upload the document."}
                        </p>
                      </Dragger>
                      {resumeFile && (
                        <div className="file-info">
                          <Flex gap={"1rem"} align="center">
                            <IconAttachment />
                            <span>Current file: {resumeFile.fileName}</span>
                          </Flex>
                        </div>
                      )}
                    </div>
                  </Form.Item>
                </Col>
              </Row>

              <div className="submit-form">
                <ButtonComponent label="Submit Form" varient="primary" htmlType="submit" />
              </div>
            </Form>
          </div>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default GuidePlatform;
